"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.ToggleDot = exports.ToggleLabel = exports.ToggleCheckbox = exports.ToggleText = exports.Wrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var Wrapper = (0, _styled.default)('div')(function (_ref) {
  var alignment = _ref.alignment;
  return {
    display: 'flex',
    justifyContent: alignment,
    alignItems: 'center'
  };
});
exports.Wrapper = Wrapper;
var ToggleText = (0, _styled.default)('span')(function (_ref2) {
  var space = _ref2.theme.space;
  return {
    maxWidth: 'calc(100% - 5rem)',
    margin: "0 ".concat(space.xsmall)
  };
});
exports.ToggleText = ToggleText;
var ToggleCheckbox = (0, _styled.default)('input')(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      colors = _ref3$theme.colors,
      toggle = _ref3$theme.toggle;
  return {
    height: 0,
    width: 0,
    visibility: 'hidden',
    display: 'none',
    ':checked + label': {
      background: colors[toggle.bgChecked]
    },
    ':checked + label :only-child': {
      left: 'calc(100% - 0.2rem)',
      transform: 'translateX(-100%)'
    }
  };
});
exports.ToggleCheckbox = ToggleCheckbox;
var ToggleLabel = (0, _styled.default)('label')(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      space = _ref4$theme.space;
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    width: '5rem',
    height: '2.6rem',
    background: colors.greydark,
    borderRadius: space.xxlarge,
    position: 'relative',
    transition: 'background-color .2s',
    maxWidth: '32rem'
  };
});
exports.ToggleLabel = ToggleLabel;
var ToggleDot = (0, _styled.default)('span')(function (_ref5) {
  var colors = _ref5.theme.colors;
  return {
    content: '""',
    position: 'absolute',
    top: '0.2rem',
    left: '0.2rem',
    width: '2.2rem',
    height: '2.2rem',
    borderRadius: '2.8rem',
    transition: '0.2s',
    background: colors.white,
    boxShadow: '0 0 0.2rem 0 rgba(10, 10, 10, 0.29)',
    ':active': {
      width: '3.0rem'
    }
  };
});
exports.ToggleDot = ToggleDot;
var _default = ToggleText;
exports.default = _default;